import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { Field } from 'react-final-form';
import ErrorMessage from '../components/error-message';
import { AnswerType } from '../generated-types';
import { requiredField, requiresAtLeastOneCheckboxSelected } from '../util/validator';
import { CheckboxField } from './checkbox-field';
import { SubQuestionRenderer } from './sub-question-renderer';
export const CheckboxListField = _ref => {
  let {
    question,
    name,
    selectedValues
  } = _ref;
  const getConditionalSubQuestions = () => {
    if (question.subQuestions && question.showSubQuestionsCondition && selectedValues && selectedValues.listAnswers) {
      if (selectedValues.listAnswers.includes(question.showSubQuestionsCondition.id)) {
        return /*#__PURE__*/React.createElement("div", null, question.subQuestions.map((subQuestion, index) => {
          return /*#__PURE__*/React.createElement(SubQuestionRenderer, {
            index: index,
            name: name,
            subQuestion: subQuestion,
            key: name,
            validate: requiredField
          });
        }));
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  const getErrorIfNoneSelected = (input, meta) => {
    if (meta.touched && meta.error && typeof meta.error === 'string') {
      return /*#__PURE__*/React.createElement("div", {
        className: "medium-margin-top"
      }, /*#__PURE__*/React.createElement(ErrorMessage, {
        text: meta.error
      }));
    }
    return '';
  };
  const getAnswerValueList = (valueId, target) => {
    var _selectedValues$listA;
    if (selectedValues && (_selectedValues$listA = selectedValues.listAnswers) !== null && _selectedValues$listA !== void 0 && _selectedValues$listA.includes(target.value) && target.checked === false) {
      var _selectedValues$listA2;
      const indexOfTargetValue = selectedValues.listAnswers.indexOf(target.value);
      const newValues = [...((_selectedValues$listA2 = selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.listAnswers) !== null && _selectedValues$listA2 !== void 0 ? _selectedValues$listA2 : [])];
      newValues.splice(indexOfTargetValue, 1);
      return newValues;
    }
    return selectedValues && selectedValues.listAnswers ? [...selectedValues.listAnswers, target.value] : [target.value];
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
    name: name,
    validate: requiresAtLeastOneCheckboxSelected,
    render: _ref2 => {
      let {
        input,
        meta
      } = _ref2;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-control"
      }, /*#__PURE__*/React.createElement("label", {
        className: "sgw-select__label"
      }, /*#__PURE__*/React.createElement("span", {
        className: "sgw-select__mainlabel"
      }, question.text)), question.possibleValues.map(possibleValue => {
        return /*#__PURE__*/React.createElement("div", {
          className: "checkbox-field",
          key: possibleValue.id
        }, /*#__PURE__*/React.createElement(CheckboxField, {
          name: name,
          label: possibleValue.text,
          value: possibleValue.id,
          id: possibleValue.id,
          onChangeOverride: event => {
            return {
              listAnswers: getAnswerValueList(possibleValue.id, event.target),
              questionId: question.id,
              questionVersion: question.version,
              answerType: AnswerType.SIMPLE_LIST,
              subQuestion: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.subQuestion
            };
          }
        }));
      }), getConditionalSubQuestions(), getErrorIfNoneSelected(input, meta));
    }
  }));
};